
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon material-attach-file","d":"M52.44 22.77L35 52.92a12.11 12.11 0 11-21.26-11.54q.15-.29.33-.57L33 8a7.57 7.57 0 0113.1 7.61L30.2 43.14a3 3 0 01-5.24-3l14.38-24.9-3.94-2.31L21 37.84a7.57 7.57 0 1013.11 7.57L50 17.88A12.11 12.11 0 0029 5.77L10.14 38.54a16.66 16.66 0 1028.29 17.6c.19-.31.37-.63.54-1l17.41-30.09z"}})])
          )
        }
      }
    